import { defaultRatingScale } from "constants/constants";
import React from "react";
import {
  RatingButton,
  RatingButtonGroup,
  RatingWrapper,
  LabelEnd,
  LabelStart,
  RatingWrap
} from "./rating.styles";
import { IRatingProps } from "./rating.types";
import { useRating } from "./useRating";
const Rating: React.FC<IRatingProps> = ({
  scale,
  setScale,
  label,
  ratingScale = defaultRatingScale,
  ratingClickCallback
}) => {
  const { handleKeyPress, handleRatingClick } = useRating(
    setScale,
    ratingClickCallback
  );

  return (
    <RatingWrapper>
      <LabelStart>{label.start}</LabelStart>
      <LabelEnd>{label.end}</LabelEnd>
      <RatingButtonGroup role="radiogroup">
        {ratingScale.map((scaleUnit, index) => (
          <React.Fragment key={`rating-${scaleUnit}`}>
            <RatingButton
              tabIndex={0}
              role="radio"
              aria-label={`rating ${scaleUnit}`}
              aria-checked={scaleUnit === scale}
              key={scaleUnit}
              isSelected={scaleUnit === scale}
              onClick={() => handleRatingClick(scaleUnit)}
              onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                handleKeyPress(e, scaleUnit)
              }>
              {scaleUnit}
            </RatingButton>
            {index === 4 && <RatingWrap key="rating-wrap" />}
          </React.Fragment>
        ))}
      </RatingButtonGroup>
    </RatingWrapper>
  );
};

export { Rating };
